import { lt, useToggle } from '@mews/framework';
import { IconName } from '@optimus-web/core';
import { OverlayedLoader } from '../../common';
import { TooltippedIconButton } from '../../tooltip';
import { PageLayout } from '../PageLayout';
import { FilterSidebarLayoutBaseProps } from './types';

/**
 * Layout for creating views with sidebar
 * @param props.loading - boolean flag to to show spinner overlay over the entire layout
 * @description Also takes PageHeader props
 */
export const FilterSidebarLayoutBase = ({
    children,
    actions = [],
    loading,
    filterSidebarOpenedByDefault = true,
    withToggleFilterHeaderAction = true,
    padded = true,
    ...other
}: FilterSidebarLayoutBaseProps) => {
    const [showSidebar, toggleSidebar] = useToggle({ initialValue: filterSidebarOpenedByDefault });

    const headerActions = (
        <>
            {actions}
            {withToggleFilterHeaderAction && (
                <TooltippedIconButton
                    tooltip={lt('Filter')}
                    variant="tertiary"
                    size="medium"
                    icon={IconName.Filter}
                    type="button"
                    onClick={toggleSidebar}
                />
            )}
        </>
    );

    return (
        <PageLayout actions={headerActions} padded={padded} {...other}>
            {children({ showSidebar, toggleSidebar })}
            <OverlayedLoader show={loading} />
        </PageLayout>
    );
};
